import { PoliticaDura } from './../../../_models/politica-duras';
import { NavService } from './../../../_services/_nav.service';
import { PoliticasDuraService } from './../../../_services/politicas-dura.service';
import { PoliticasDurasDivisionesPoliticasService } from '../../../_services/politicas-duras-divisiones-politicas.service';
import { PoliticaDuraDivisionPolitica } from '../../../_models/politica-dura-division-politica';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-politicas-duras-detalle',
  templateUrl: './politicas-duras-detalle.component.html',
  styleUrls: ['./politicas-duras-detalle.component.css'],
})
export class PoliticasDurasDetalleComponent implements OnInit {

  carInformacionInicial = true;
  politicaDura: PoliticaDura;

  columnas = [];
  politicasDurasDivisionesPoliticas: PoliticaDuraDivisionPolitica[] = [];
  carPoliticasDuras = true;
  busqueda: string;
  @ViewChild('dt') table: Table;

  constructor(
    private polDurasServicio: PoliticasDuraService,
    private route: ActivatedRoute,
    private nav: NavService,
    private location: Location,
    private politicasDurasDivisionesPoliticasService: PoliticasDurasDivisionesPoliticasService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      forkJoin(
        this.polDurasServicio.obtenerPorId(params['id']),
      ).subscribe(([polDura]) => {
        this.politicaDura = polDura;

        if (this.politicaDura && this.politicaDura.codigotipoPoliticaDura === 'CIUNAPLI') {
          this.cargarTabla();
        }

        this.carInformacionInicial = false;
      });
    });
  }

  async cargarTabla() {
    this.columnas = [
      {
        field: 'camino',
        header: this.nav.buscarMensaje('LBL_CIUDAD'),
        sort: true,
      }
    ];
    await this.cargarDatosTabla();
  }

  async cargarDatosTabla() {
    this.politicasDurasDivisionesPoliticasService.obtenerPorIdPoliticaDura(this.politicaDura.idPoliticaDura).subscribe(data => {
      this.politicasDurasDivisionesPoliticas = data;
      this.carPoliticasDuras = false;

      // Aplicar búsqueda guardada si existe
      this.busqueda = this.nav.getSearch('politicas-duras-detalle.component');
      if (this.table && this.busqueda) {
        this.table.filterGlobal(this.busqueda, 'contains');
      }
    });
  }

  setSearch() {
    this.nav.setSearch('politicas-duras-detalle.component', this.busqueda);
  }

  regresar() {
    this.location.back();
  }
}
